import React, { useState } from 'react';
import { X, Filter, Search } from 'lucide-react';

const FilterModal = ({ onClose, onApply, currentFilters = {} }) => {
  const [filters, setFilters] = useState({
    insurance: currentFilters.insurance || '',
    status: currentFilters.status || '',
    office: currentFilters.office || '',
    dateFrom: currentFilters.dateFrom || '',
    dateTo: currentFilters.dateTo || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    onApply(filters);
    onClose();
  };

  const handleClear = () => {
    setFilters({
      insurance: '',
      status: '',
      office: '',
      dateFrom: '',
      dateTo: ''
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="bg-[#5bc0de] text-white px-4 py-3 rounded-t-lg flex items-center justify-between">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <Filter className="w-5 h-5" /> Advanced Filters
          </h2>
          <button onClick={onClose} className="hover:bg-white/20 p-1 rounded">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Filters */}
        <div className="p-6 space-y-4">
          {/* Insurance */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Insurance</label>
            <select
              name="insurance"
              value={filters.insurance}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">All Insurance</option>
              <option value="CIGNA">CIGNA</option>
              <option value="Medicare">Medicare</option>
              <option value="Medicaid">Medicaid</option>
              <option value="Aetna">Aetna</option>
              <option value="Blue Cross Blue Shield">Blue Cross Blue Shield</option>
              <option value="United Healthcare">United Healthcare</option>
              <option value="Humana">Humana</option>
              <option value="Anthem">Anthem</option>
              <option value="WellCare">WellCare</option>
              <option value="Tricare">Tricare</option>
            </select>
          </div>

          {/* Status */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
            <select
              name="status"
              value={filters.status}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Discharged">Discharged</option>
            </select>
          </div>

          {/* Office */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Office</label>
            <select
              name="office"
              value={filters.office}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">All Offices</option>
              <option value="Ivory Home Health Care, Inc.">Ivory Home Health Care, Inc.</option>
            </select>
          </div>

          {/* Date Range */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Admit Date From</label>
              <input
                type="date"
                name="dateFrom"
                value={filters.dateFrom}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Admit Date To</label>
              <input
                type="date"
                name="dateTo"
                value={filters.dateTo}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-between gap-3 px-6 pb-6">
          <button
            onClick={handleClear}
            className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
          >
            Clear All
          </button>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleApply}
              className="px-4 py-2 bg-[#5bc0de] text-white rounded hover:bg-[#4ab0ce] flex items-center gap-2"
            >
              <Search className="w-4 h-4" /> Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
